import { render } from "./CustomersV2.vue?vue&type=template&id=f79ba8d0&scoped=true"
import script from "./CustomersV2.vue?vue&type=script&lang=ts"
export * from "./CustomersV2.vue?vue&type=script&lang=ts"

import "./CustomersV2.vue?vue&type=style&index=0&id=f79ba8d0&scoped=true&lang=css"
import "./CustomersV2.vue?vue&type=style&index=1&id=f79ba8d0&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-f79ba8d0"

export default script